import styled from "styled-components";

export const StyledSectionContent = styled.section`

    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 2rem;

    @media (min-width: 768px){
        padding-top: 5rem;
    }

    h1{
        font-size: 3rem;
        color: var(--dark--primary--text);
    }

    .icon{
        color: var(--dark--green--50);
    }

    ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 2rem;

        @media (min-width: 768px){
            width: 70%;
        }

        li{
            margin: 2rem;
        }
        
        i{
            font-size: 5rem;
        }
    }

`